import { z } from 'zod';

export const ManagedUser = z.object({
    id: z.string(),
    depth: z.number(),
    asSubstituteOf: z.string().optional(),
});

export type ManagedUser = z.infer<typeof ManagedUser>;
